import apiClient from '@u/apiClient'
import IndexScheduledTaskController from '@/wayfinder/actions/App/Http/Controllers/ScheduledTask/IndexScheduledTaskController'
import ShowScheduledTaskController from '@/wayfinder/actions/App/Http/Controllers/ScheduledTask/ShowScheduledTaskController'
import StoreScheduledTaskController from '@/wayfinder/actions/App/Http/Controllers/ScheduledTask/StoreScheduledTaskController'
import UpdateScheduledTaskController from '@/wayfinder/actions/App/Http/Controllers/ScheduledTask/UpdateScheduledTaskController'
import PatchScheduledTaskController from '@/wayfinder/actions/App/Http/Controllers/ScheduledTask/PatchScheduledTaskController'
import DuplicateScheduledTaskController from '@/wayfinder/actions/App/Http/Controllers/ScheduledTask/DuplicateScheduledTaskController'
import DeleteScheduledTaskController from '@/wayfinder/actions/App/Http/Controllers/ScheduledTask/DeleteScheduledTaskController'

export default {
  fetchScheduledTaskList() {
    return new Promise((resolve, reject) => {
      apiClient
        .route(IndexScheduledTaskController.get())
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchScheduledTasksByTemplateId(_, templateId) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(IndexScheduledTaskController.get(), {
          params: { schedulable_id: templateId }
        })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchScheduledTaskById(_, id) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ShowScheduledTaskController.get({ scheduled_task: id }))
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  createScheduledTask(_, data) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(StoreScheduledTaskController.post(), data, {
          skipValidationToast: data.action === 'close_supplier_orders'
        })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  updateScheduledTask(_, { id, data }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateScheduledTaskController.put({ scheduled_task: id }),
          data,
          {
            skipValidationToast: data.action === 'close_supplier_orders'
          }
        )
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  toggleScheduledTask(_, { id, active }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(PatchScheduledTaskController.patch({ scheduled_task: id }), {
          active
        })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  duplicateScheduledTask(_, id) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DuplicateScheduledTaskController.post({ scheduled_task: id }))
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  deleteScheduledTask(_, id) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteScheduledTaskController.delete.delete({ scheduled_task: id })
        )
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  }
}
